/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import ErrorIcon from "@mui/icons-material/Error";
import { Box, FormHelperText } from "@mui/material";
import { FC, type JSX } from "react";

import TestIds from "../../../testIds";

import styles from "./FormControlMessage.module.scss";

export interface IFormControlMessageProps {
  "data-testid"?: string;
  hint?: string;
  errorMessage?: string;
  error?: boolean;
}

const FormControlMessage: FC<IFormControlMessageProps> = ({
  "data-testid": testId,
  hint,
  errorMessage,
  error,
}: IFormControlMessageProps): JSX.Element | undefined => {
  if (hint || (error && errorMessage)) {
    return (
      <Box
        component="span"
        className={styles.flFormControlMessage}
        data-testid={TestIds.components.formControls.message.component(testId)}
      >
        {error && (
          <Box component="span" className={styles.flFormControlMessage__iconContainer}>
            <ErrorIcon
              className={styles.flFormControlMessage__icon}
              data-testid={TestIds.components.formControls.message.errorIcon(testId)}
            />
          </Box>
        )}
        <FormHelperText className={styles.flFormControlMessage__message} error={error}>
          {error ? errorMessage : hint}
        </FormHelperText>
      </Box>
    );
  }
};

export default FormControlMessage;
